import axios from 'axios'
import { SupportedBrands } from 'src/enums'
import { UserFeature, UserFeatureList } from 'src/models/user.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export interface UserFeaturesResponse {
  features: UserFeatureList
}

export type BrandRedirectResponse = {
  id: string
  name: string
  slug: SupportedBrands
  host: string
}

interface BrandCheckResponse {
  brandCheck: {
    suggestedBrands: BrandRedirectResponse[]
  }
}

export const getUserFeatures = async (
  features: UserFeature[],
): Promise<UserFeaturesResponse> =>
  getResponseData(
    axios.get<UserFeaturesResponse>(
      `/features?features=${features.join(',')}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

// Keeps the legacy raw-axios error propagation (no normalizeQueryError) that
// the inline useQueryBrandRedirectSuggestions queryFn used — no consumer reads
// this query's `error`, so bit-for-bit parity is preserved. `withCredentials`
// mirrors the original request. getRequestConfig(Default) resolves the same
// authed JSON config the hook previously read via useRequestConfig().
export const postBrandCheck = async (
  email: string,
): Promise<BrandRedirectResponse[]> => {
  const response = await axios.post<BrandCheckResponse>(
    '/brandcheck',
    { email },
    { ...getRequestConfig(RequestConfig.Default), withCredentials: true },
  )
  return response.data.brandCheck.suggestedBrands
}
